/**
 * upsell-carousel.js — desktop prev/next arrows for the cart upsell row.
 *
 * The upsell lays out as a native CSS scroll-snap row (great on touch). On
 * desktop this wires arrow buttons that scroll it, disables them at the ends,
 * and hides the whole set when there's nothing to scroll. Decoupled from
 * theme.js; re-wires on cart events + when the drawer template clones in.
 */
(function () {
  'use strict';

  function update(row, prev, next, wrap) {
    const max = row.scrollWidth - row.clientWidth;
    prev.classList.toggle('is-disabled', row.scrollLeft <= 1);
    next.classList.toggle('is-disabled', row.scrollLeft >= max - 1);
    wrap.classList.toggle('upsell-carousel--static', max <= 1);
  }

  function wire(wrap) {
    if (wrap.dataset.upsellWired) return;
    const row = wrap.querySelector('[data-pair-products]');
    const prev = wrap.querySelector('[data-upsell-nav="prev"]');
    const next = wrap.querySelector('[data-upsell-nav="next"]');
    if (!row || !prev || !next) return;
    wrap.dataset.upsellWired = '1';

    const step = () => Math.max(row.clientWidth * 0.8, 170);
    prev.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));
    row.addEventListener('scroll', () => update(row, prev, next, wrap), { passive: true });
    window.addEventListener('resize', () => update(row, prev, next, wrap));

    update(row, prev, next, wrap);
    requestAnimationFrame(() => update(row, prev, next, wrap));
  }

  function wireAll() {
    document.querySelectorAll('[data-upsell-carousel]').forEach(wire);
  }

  ['theme:cart:added', 'theme:cart:update', 'theme:cart:refresh'].forEach((ev) => {
    document.addEventListener(ev, () => setTimeout(wireAll, 0));
  });

  const drawer = document.getElementById('cart-drawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(() => wireAll()).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
})();
